
/**
 * 콘텐츠 타입
 */
export type CourseDraftSectionsItemLecturesItemContentType = typeof CourseDraftSectionsItemLecturesItemContentType[keyof typeof CourseDraftSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
